/*
 * LE NOM · personalizzazioni nel carrello (sostituisce snippets/ln-cart-action.liquid)
 *
 * Righe create da configCheckout (snippets/ln-product-configurator.liquid):
 *  - riga PRINCIPALE (la borsa): properties._config_personalization_id, nessuna _type
 *  - righe PERSONALIZZAZIONE: stesso _config_personalization_id + _type (text|symbol|image)
 *
 * Invarianti mantenute, lavorando sempre su /cart.js (nessun dato Liquid):
 *  1) una riga personalizzazione senza la sua riga principale viene rimossa (orfana)
 *  2) la quantità di ogni riga personalizzazione segue quella della riga principale
 *
 * - Cascata immediata: CartItems.prototype.updateQuantity (assets/cart.js, non modificato) è avvolto;
 *   se la riga appartiene a un bundle, UNA sola POST /cart/update.js indicizzata per key aggiorna
 *   tutte le righe del bundle e restituisce le sezioni di drawer / pagina carrello / contatore header,
 *   sostituite con lo stesso meccanismo di Dawn.
 * - Riconciliazione: al caricamento pagina e a ogni PUB_SUB_EVENTS.cartUpdate non generato da qui.
 *   Nessuna richiesta di modifica se il carrello è già coerente.
 */
(function () {
  'use strict';

  if (window.lnCartPersonalization) return;

  var BUNDLE_PROP = '_config_personalization_id';
  var TYPE_PROP = '_type';
  var MARK = 'lnCartPersonalization';
  var MAX_SECTIONS = 5; // limite Shopify del parametro "sections"

  var queue = Promise.resolve();
  var reconcileQueued = false;

  function noop() {}

  function warn(message, error) {
    if (window.console && console.warn) console.warn('[ln-cart-personalization] ' + message, error || '');
  }

  function call(target, method) {
    if (!target || typeof target[method] !== 'function') return;
    try {
      target[method].apply(target, Array.prototype.slice.call(arguments, 2));
    } catch (e) {
      /* vista già sostituita o markup assente */
    }
  }

  function cartString(name) {
    return (window.cartStrings && window.cartStrings[name]) || '';
  }

  /* ------------------------------------------------------------------ rete */

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function readJson(response) {
    return response.json().then(function (data) {
      if (!response.ok || !data || (typeof data.status === 'number' && !data.items)) {
        var error = new Error((data && (data.description || data.message)) || 'HTTP ' + response.status);
        error.cartMessage = data && (data.description || data.message);
        throw error;
      }
      return data;
    });
  }

  function getCart() {
    return fetch(route('cart_url', '/cart') + '.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(readJson);
  }

  function postUpdates(updates, views) {
    var body = { updates: updates };
    var ids = sectionIds(views);
    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }
    return fetch(route('cart_update_url', '/cart/update') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(readJson);
  }

  function getSections(views) {
    var ids = sectionIds(views);
    if (!ids.length) return Promise.resolve({});
    // come CartItems.onCartUpdate (rotta carrello, nessun header Accept: con "Accept: application/json"
    // la rotta carrello risponde col JSON del carrello invece che con la mappa delle sezioni)
    return fetch(route('cart_url', '/cart') + '?sections=' + encodeURIComponent(ids.join(',')), {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(readJson);
  }

  // operazioni serializzate: ognuna rilegge /cart.js dopo la precedente
  function enqueue(task) {
    var run = queue.then(task);
    queue = run.then(noop, noop);
    return run;
  }

  /* --------------------------------------------------------------- modello */

  function bundleIdOf(item) {
    var value = item && item.properties && item.properties[BUNDLE_PROP];
    return value ? String(value) : null;
  }

  function isPersonalizationLine(item) {
    return !!(item && item.properties && item.properties[TYPE_PROP]);
  }

  function indexOfKey(items, key) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === key) return i;
    }
    return -1;
  }

  // Checkout in corso: configCheckout aggiunge le righe personalizzazione PRIMA della borsa
  // (cart/add.js -> render canvas -> submit del product-form) e imposta
  // window.lnConfigCheckoutPending = '<bundleId>' per tutta la durata. In quella finestra il bundle
  // senza riga principale non è orfano. Difesa in più: aggiunta del product-form ancora in volo.
  function isCheckoutPending(bundleId) {
    var pending = window.lnConfigCheckoutPending;
    if (pending === true || (pending && String(pending) === bundleId)) return true;
    return !!document.querySelector('product-form [type="submit"].loading');
  }

  // Aggiornamenti { key: quantità } che riportano i bundle alle invarianti; null = niente da cambiare.
  // intent (facoltativo) = { key, quantity }: modifica dell'utente applicata prima delle invarianti.
  // Le righe senza _config_personalization_id non vengono mai incluse.
  function planUpdates(items, intent) {
    var desired = {};
    var groups = {};
    var bundleIds = [];
    var updates = null;

    items.forEach(function (item) {
      desired[item.key] = intent && intent.key === item.key ? intent.quantity : item.quantity;
      var bundleId = bundleIdOf(item);
      if (!bundleId) return;
      if (!groups[bundleId]) {
        groups[bundleId] = { mains: [], lines: [] };
        bundleIds.push(bundleId);
      }
      groups[bundleId][isPersonalizationLine(item) ? 'lines' : 'mains'].push(item);
    });

    bundleIds.forEach(function (bundleId) {
      var group = groups[bundleId];
      var mainQuantity = 0;
      if (!group.mains.length && isCheckoutPending(bundleId)) return;
      group.mains.forEach(function (item) {
        mainQuantity += desired[item.key];
      });
      group.lines.forEach(function (item) {
        if (desired[item.key] > 0) desired[item.key] = mainQuantity;
      });
    });

    items.forEach(function (item) {
      if (desired[item.key] !== item.quantity) {
        updates = updates || {};
        updates[item.key] = desired[item.key];
      }
    });
    return updates;
  }

  /* ------------------------------------ viste: drawer, pagina carrello, header */

  // Sezioni prese dalle istanze Dawn presenti (getSectionsToRender di CartItems / CartDrawerItems):
  // la stessa POST aggiorna la vista che ha avviato l'azione e le altre (es. drawer sulla pagina carrello).
  function collectViews(initiator) {
    var views = [];
    var hasBubble = false;
    var nodes = Array.prototype.slice.call(document.querySelectorAll('cart-drawer-items, cart-items'));
    var position = initiator ? nodes.indexOf(initiator) : -1;

    if (position > 0) nodes.unshift(nodes.splice(position, 1)[0]);

    nodes.forEach(function (node) {
      if (typeof node.getSectionsToRender !== 'function') return;
      try {
        var sections = node.getSectionsToRender();
        sections.forEach(function (section) {
          if (section.section === 'cart-icon-bubble') hasBubble = true;
        });
        views.push({ node: node, sections: sections });
      } catch (e) {
        /* markup di questa vista assente nella pagina */
      }
    });

    if (!hasBubble && document.getElementById('cart-icon-bubble')) {
      views.push({
        node: null,
        sections: [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }]
      });
    }
    return views;
  }

  function sectionIds(views) {
    var ids = [];
    views.forEach(function (view) {
      view.sections.forEach(function (section) {
        if (section.section && ids.indexOf(section.section) === -1 && ids.length < MAX_SECTIONS) {
          ids.push(section.section);
        }
      });
    });
    return ids;
  }

  // Stessa sostituzione di CartItems.updateQuantity; restituisce true se il focus era nel drawer aperto.
  function renderViews(views, cart) {
    var empty = cart.item_count === 0;
    var sections = cart.sections || {};
    var drawer = document.querySelector('cart-drawer');
    var footer = document.getElementById('main-cart-footer');
    var focusInDrawer = !!(drawer && drawer.classList.contains('active') && drawer.contains(document.activeElement));
    var done = {};

    Array.prototype.forEach.call(document.querySelectorAll('cart-items, cart-drawer-items'), function (node) {
      node.classList.toggle('is-empty', empty);
    });
    if (footer) footer.classList.toggle('is-empty', empty);
    if (drawer) drawer.classList.toggle('is-empty', empty);

    views.forEach(function (view) {
      view.sections.forEach(function (section) {
        var host = document.getElementById(section.id);
        var uid = section.id + ' ' + section.selector;
        if (!host || !sections[section.section] || done[uid]) return;
        var source = new DOMParser()
          .parseFromString(sections[section.section], 'text/html')
          .querySelector(section.selector);
        if (!source) return;
        (host.querySelector(section.selector) || host).innerHTML = source.innerHTML;
        done[uid] = true;
      });
    });
    return focusInDrawer;
  }

  // come CartDrawer.open: il focus resta intrappolato nel drawer aperto dopo la sostituzione
  function trapDrawerFocus(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active') || typeof trapFocus !== 'function') return;
    var container = cart.item_count === 0 ? drawer.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
    var target = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
    if (!container || !target) return;
    try {
      trapFocus(container, target);
    } catch (e) {
      /* noop */
    }
  }

  function publishUpdate(cart, variantId) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    // source 'cart-items': le viste sono già aggiornate, CartItems.onCartUpdate non ri-scarica le sezioni
    var event = { source: 'cart-items', cartData: cart, variantId: variantId };
    event[MARK] = true; // ignorato dalla riconciliazione (niente cicli)
    publish(PUB_SUB_EVENTS.cartUpdate, event);
  }

  function quantityInput(view, line) {
    return view && view.querySelector ? view.querySelector('input[data-index="' + line + '"]') : null;
  }

  function resetQuantityInput(view, line) {
    var input = quantityInput(view, line);
    if (input && input.hasAttribute('value')) input.value = input.getAttribute('value');
  }

  /* --------------------------------------------------- cascata (azione utente) */

  function handleQuantity(view, original, args) {
    var line = parseInt(args[0], 10);
    var quantity = parseInt(args[1], 10);

    if (!(line > 0) || !(quantity >= 0)) return original.apply(view, args);

    call(view, 'enableLoading', line);

    enqueue(function () {
      return getCart().then(function (cart) {
        var items = cart.items || [];
        var item = items[line - 1];
        var input = quantityInput(view, line);
        var domVariant = input && input.getAttribute('data-quantity-variant-id');
        var views, updates, inDrawer;

        // la vista non corrisponde più al carrello reale (es. cambiato in un'altra scheda):
        // nessuna modifica alla cieca, solo riallineamento delle viste
        if (!item || (domVariant && String(item.variant_id) !== String(domVariant))) {
          views = collectViews(view);
          return getSections(views).then(function (sections) {
            cart.sections = sections;
            renderViews(views, cart);
            call(view, 'disableLoading', line);
          });
        }

        // riga senza personalizzazione: comportamento Dawn invariato
        if (!bundleIdOf(item)) {
          original.apply(view, args);
          return;
        }

        updates = planUpdates(items, { key: item.key, quantity: quantity });
        if (!updates) {
          // niente da cambiare (es. quantità di una riga personalizzazione: segue sempre la borsa)
          resetQuantityInput(view, line);
          call(view, 'disableLoading', line);
          return;
        }

        views = collectViews(view);
        inDrawer = !!(view.closest && view.closest('cart-drawer'));

        return postUpdates(updates, views).then(function (updated) {
          var index = indexOfKey(updated.items, item.key);
          var message = '';

          renderViews(views, updated);

          if (quantity > 0) {
            if (index === -1) message = cartString('error');
            else if (updated.items[index].quantity !== quantity) {
              message = cartString('quantityError').replace('[quantity]', updated.items[index].quantity);
            }
          }
          call(view, 'updateLiveRegions', index === -1 ? line : index + 1, message);
          if (inDrawer) trapDrawerFocus(updated);
          call(view, 'disableLoading', line);
          publishUpdate(updated, args[3]);

          // quantità ridotte dal server (disponibilità): ripristina le invarianti
          if (planUpdates(updated.items)) requestReconcile();
        });
      });
    }).catch(function (error) {
      warn('aggiornamento del carrello non riuscito', error);
      resetQuantityInput(view, line);
      if (error && error.cartMessage) {
        call(view, 'updateLiveRegions', line, error.cartMessage);
      } else {
        var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = cartString('error');
      }
      call(view, 'disableLoading', line);
    });
  }

  /* ------------------------------------------------ riconciliazione (rete di sicurezza) */

  function requestReconcile() {
    if (reconcileQueued) return;
    reconcileQueued = true;
    enqueue(function () {
      reconcileQueued = false;
      return reconcile();
    });
  }

  function reconcile() {
    return getCart()
      .then(function (cart) {
        var updates = planUpdates(cart.items || []);
        var views;
        if (!updates) return; // carrello coerente: nessuna richiesta
        views = collectViews(null);
        return postUpdates(updates, views).then(function (updated) {
          if (renderViews(views, updated)) trapDrawerFocus(updated);
          publishUpdate(updated);
        });
      })
      .catch(function (error) {
        warn('riconciliazione del carrello non riuscita', error);
      });
  }

  function onCartUpdate(event) {
    if (event && event[MARK]) return; // evento generato da questo script
    requestReconcile();
  }

  function wrapUpdateQuantity(tagName) {
    customElements.whenDefined(tagName).then(function () {
      var ctor = customElements.get(tagName);
      var proto = ctor && ctor.prototype;
      var original;
      if (!proto || typeof proto.updateQuantity !== 'function' || proto.updateQuantity[MARK]) return;
      original = proto.updateQuantity;
      proto.updateQuantity = function () {
        return handleQuantity(this, original, arguments);
      };
      proto.updateQuantity[MARK] = true;
    });
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
    requestReconcile();
  }

  window.lnCartPersonalization = { reconcile: requestReconcile, planUpdates: planUpdates };

  if (window.customElements) {
    wrapUpdateQuantity('cart-items');
    wrapUpdateQuantity('cart-drawer-items');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // ritorno dalla cache back/forward: il carrello può essere cambiato altrove
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) requestReconcile();
  });
})();
